import React, { FC } from 'react';

import WayshipDropdownDeck from './WayshipDropdownDeck';
import { IData } from '.';


interface ICNRRangeTypeProps {
    data: IData;
    setData: React.Dispatch<React.SetStateAction<IData>>;
}

const CNRRangeType: FC<ICNRRangeTypeProps> = ({ data, setData }) => {
    const range = [
        {
            label: 'Warning',
            value: 'WARNING',
        },
        {
            label: 'Error',
            value: 'ERROR',
        },
    ];
    return (
			<div>
				<WayshipDropdownDeck
					title="Select range type"
					dataKey=""
					value={data?.rangeType ?? "WARNING"}
					range={range}
					isSubmit={data?.range?.every(
						(rangeVal) => typeof rangeVal === "undefined" || rangeVal === null
					)}
					onChangeHandler={(selectedItem: any, dataKey: any) => {
						if (selectedItem) {
							setData((prev) => ({
								...prev,
								rangeType: selectedItem,
							}));
						}
					}}
				/>
			</div>
		);
};

export default CNRRangeType;
